<template>
  <v-snackbar v-model="show" :timeout="2000" outlined style="z-index: 205; top: 20px" top>
    {{ contents }}
    <div>
      {{ format(new Date(), 'yyyy-MM-dd HH:mm:ss') }}
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="show = false">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import format from 'date-fns/format';

export default {
  computed: {
    ...mapState('components/snackbar', ['contents']),
    show: {
      get() {
        return this.contents != null;
      },
      set() {
        this.setContents(null);
      },
    },
  },
  methods: {
    ...mapActions('components/snackbar', ['setContents']),
    format,
  },
};
</script>

<style lang="scss" scoped></style>
